var render, staticRenderFns
import script from "./accountStated.vue?vue&type=script&lang=js&"
export * from "./accountStated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578a81e",
  null
  
)

export default component.exports